import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import Index from '../pages/index';
import LoginCallback from '../pages/login/callback';
import SsoRedirect from '../pages/login/sso-redirect';
import ForgotPassword from '../pages/forgot-password';
import ResetPassword from '../pages/reset-password';
import AcceptInvitation from '../pages/accept-invitation';

export const authRoutes = () => (
  <>
    <Route path={ROUTES.INDEX} element={<Index />} />
    <Route path={ROUTES.LOGIN_CALLBACK} element={<LoginCallback />} />
    <Route path={ROUTES.LOGIN_SSO_REDIRECT} element={<SsoRedirect />} />
    <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
    <Route path={ROUTES.ACCEPT_INVITATION} element={<AcceptInvitation />} />
  </>
);
